
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#c3afa3"}},[_c('path',{attrs:{"d":"M3.376 14.25a.563.563 0 01-.563-.562v-4.5a.563.563 0 01.563-.563h.9a1.465 1.465 0 011.464 1.462v.45a1.455 1.455 0 01-.189.713.371.371 0 000 .374 1.467 1.467 0 01.188.713v.45a1.466 1.466 0 01-1.464 1.463z"}}),_c('path',{attrs:{"data-name":"Shape","d":"M4.614 7.313v-.9a.338.338 0 10-.675 0v.9a.563.563 0 01-1.125 0v-3.6a1.463 1.463 0 012.925 0v3.6a.563.563 0 11-1.125 0z"}}),_c('path',{attrs:{"d":"M8.401 3H7.276a.563.563 0 000 1.125h1.125a.563.563 0 000-1.125z"}}),_c('path',{attrs:{"data-name":"Path","d":"M8.964 9.563A.563.563 0 008.401 9H7.276a.563.563 0 100 1.125h1.125a.563.563 0 00.563-.562z"}}),_c('path',{attrs:{"data-name":"Path","d":"M6.375 15h-4.5a.375.375 0 01-.375-.375V1.875a.375.375 0 01.375-.375h6.5a.75.75 0 01.53.22l2.125 2.121a.75.75 0 01.22.53V9a.75.75 0 001.5 0V4.061A1.49 1.49 0 0012.311 3L9.75.44A1.508 1.508 0 008.689 0H1.5A1.5 1.5 0 000 1.5V15a1.5 1.5 0 001.5 1.5h4.875a.75.75 0 000-1.5z"}}),_c('path',{attrs:{"data-name":"Path","d":"M17.764 12.457l-4.5-1.786a.375.375 0 00-.278 0l-4.5 1.786a.375.375 0 00-.236.356v2.348a.375.375 0 00.75 0v-1.56a.187.187 0 01.25-.176L13 14.744a.38.38 0 00.25 0l4.5-1.584a.375.375 0 00.014-.7z"}}),_c('path',{attrs:{"data-name":"Path","d":"M15.572 14.872l-2.194.778a.75.75 0 01-.5 0l-2.2-.778a.375.375 0 00-.5.354v1.609a.375.375 0 00.25.353l1.93.682a2.314 2.314 0 001.532 0l1.93-.682a.375.375 0 00.251-.353v-1.61a.375.375 0 00-.5-.354z"}})])])
          )
        }
      }
    